import React from 'react';
import {
  Button, Dialog, DialogTitle, DialogContentText, DialogActions, DialogContent
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const FailedObjectiveStatusDialog = (
  {
    closeObjectiveDialogOpen,
    setCloseObjectiveDialogOpen,
    handleFailedObjective
  }
) => {
  const { t } = useTranslation();

  const handleCloseFailedEvaluation = () => {
    handleFailedObjective();
    setCloseObjectiveDialogOpen(false);
  };

  return (
    <Dialog
      open={ closeObjectiveDialogOpen }
      onClose={ () => setCloseObjectiveDialogOpen(false) }
    >
      <DialogTitle>{t('objective.evaluation.status.dialog.lock.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('objective.evaluation.status.dialog.lock.failed_description')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={ handleCloseFailedEvaluation } color="primary" variant="contained">
          {t('objective.evaluation.status.dialog.lock.confirm')}
        </Button>
        <Button onClick={ () => setCloseObjectiveDialogOpen(false) } color="primary" autoFocus>
          {t('objective.evaluation.status.dialog.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};